<template>
  <div class="pa-2 pa-sm-4">
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Plantas"
        :Cabecera="Cabecera"
        :loading="Loader"
        :Items="Items"
        :ItemTotal="ItemTotal"
        :Excel="true"
        :Crear="true"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/plantas/tabla.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Plantas",
  components: {
    tabla,
  },
  created() {
    this.cargarPlantas();
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          sortable: false,
          width: 100,
        },
        {
          text: "Nombre de la Planta",
          value: "nombre",
          align: "left",
        },
        {
          text: "Dirección",
          value: "direccion",
          align: "left",
        },
        {
          text: "Fecha de Registro",
          value: "fecha",
          align: "center",
          width: 160,
        },
      ],
      loading: false,
    };
  },
  methods: {
    ...mapActions("plantas", ["cargarPlantas"]),
  },
  computed: {
    ...mapState("plantas", ["Items", "Loader", "ItemTotal"]),
  },
};
</script>
